export default __webpack_public_path__ + "static/media/acropass-diamond-temporary.05374af7.png";